import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'SMS_CONFIG_DETAIL',
        create: 'SMS_CONFIG_CREATE',
        update: 'SMS_CONFIG_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'sms_sType',
        default: '',
        label: this.$t('type'),
        col: {
          span: 16
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "sms_config_type",
              "button": true
            },
            "model": {
              value: _this.form.model.sms_sType,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "sms_sType", $$v);
              }
            }
          });
        }
      }, {
        prop: 'sms_cStatus',
        default: '',
        label: this.$t('status'),
        col: {
          span: 16
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "sms_configs_status",
              "button": true
            },
            "model": {
              value: _this.form.model.sms_cStatus,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "sms_cStatus", $$v);
              }
            }
          });
        }
      }, {
        prop: 'sms_config_xml',
        default: '',
        label: this.$t('sms_config_xml'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "type": "textarea",
              "autosize": true,
              "clearable": true
            },
            "model": {
              value: _this.form.model.sms_config_xml,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "sms_config_xml", $$v);
              }
            }
          });
        }
      }];
    }
  }
};